const wortHost = 'www.wort.lu';
const luxtimesHost = 'www.luxtimes.lu';
const mywortHost = 'www.mywort.lu';
//const ssoHost = 'user.wort.lu';
const notifHost = 'jobsv3.wort.lu';

const APP_CONF = {
    //domain                  : '.wort.lu',
    //host                    : wortHost,
    webHost_wort            : `https://${wortHost}`,
    webHost_luxtimes        : `https://${luxtimesHost}`,
    mywortWebHost           : `https://${mywortHost}`,
    myWort                  : `https://${mywortHost}/mywort`,

    //ssoHost                 : `https://${ssoHost}`,
    googleMapApiKey         : "AIzaSyD6-3zWECLefyBT6PnLMCQAr9P6d0bhR78",
    //twitterId               : "00651d",
    latinaWebsocketHost     : `wss://${notifHost}`,
    latinaStream            : "https://ice.creacast.com/radio-latina-lu-mp3",
    firebaseConfig : {
        apiKey: "AIzaSyAS662-Wrr743vBoJRbl8P_HCkiGOmdZGs",
        authDomain: "wortv4-test-72f9a.firebaseapp.com",
        databaseURL: "https://wortv4-test-72f9a.firebaseio.com",
        projectId: "wortv4-test-72f9a",
        storageBucket: "wortv4-test-72f9a.appspot.com",
        messagingSenderId: "360326138301",
        appId: "1:360326138301:web:2b8a0dc9e33fe30d6c2ad4",
        measurementId: "G-SSR4P0PDPK"
    },
    firebasePublicVapidKey: "BCr3czlISpCfEw-_VuKPLHl0gqnyCE1Lzd7x8ylv_FG6qCLStYQsLYJimgFl0bA_j0nReuanGKv-cjd5KUmbZag",
    firebaseAppId           : "wort-v5"
};
module.exports = APP_CONF;



// WEBPACK FOOTER //
// ../conf/prod.js